exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.chart-legend {\n  width: 205px;\n}\n.chart-legend .chart-header {\n  color: var(--primary-text-color);\n  font-size: 12px;\n  font-weight: 500;\n  padding: 16px 24px;\n}\n", ""]);

// exports
